// extracted by mini-css-extract-plugin
export default {"input":"Searchbar_input__cEZJe"};